import { container, singleton } from "tsyringe";
import { ILogElasticRequest } from "../../typings/common.types";
import { LogVerbosityLevel } from "../../typings/enums/logVerbosityLevel.enum";
import { AuthorizationService } from "./authorization.service";
import { IAuthorizationService } from "./interfaces/iAuthorization.service";
import { ILoggerService } from "./interfaces/iLoggerService";

@singleton()
export class LoggerService implements ILoggerService {
    private readonly authorizationService: IAuthorizationService = container.resolve(AuthorizationService);

    private readonly elasticSearchUrl: string = process.env.ELASTIC_SEARCH_URL || '';
    private readonly elasticSearchIndexPattern: string = process.env.ELASTIC_SEARCH_INDEX_PATTERN || '';
    

    public logMessage(message: string, verbosityLevel: LogVerbosityLevel = LogVerbosityLevel.Debug): void {
        console.log(message);

        if (verbosityLevel == LogVerbosityLevel.Debug) {
            return;
        }

        const currentUser = this.authorizationService.getCurrentUser();

        const bodyRequest: ILogElasticRequest = {
            level: LogVerbosityLevel[verbosityLevel],
            organizationId: currentUser.organizationId,
            userId: currentUser.userId,
            username: currentUser.email,
            message: message
        };


        fetch(this.elasticSearchUrl, {
            method: 'POST',
            body: JSON.stringify(bodyRequest),
            headers: {
                'Content-Type': 'application/json',
                "Application": this.elasticSearchIndexPattern
            }
        }).catch(function (ex) {
            console.log(`Error occured while sending log. Error: ${ex}`);
        });
    }
}